
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { reactive } from 'vue'
import GoalButtons from '@/components/block/GoalButtons.vue'
import FormAreaCheckbox from '@/components/block/FormAreaCheckbox.vue'
import FormRadioButtons from '@/components/block/FormRadioButtons.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import Button from '@/components/elements/Button.vue'

export default {
  name: 'HomeEasySearchModal',

  components: {
    GoalButtons,
    FormAreaCheckbox,
    FormRadioButtons,
    HeadingLv3,
    Button
  },

  setup() {
    const router = useRouter()
    const store = useStore()

    type EasySearchStateTypes = {
      modalOpen: boolean
      selectedButton: 'genre' | 'location'
      conditions: {
        genre: {
          hospital: {
            label: string
            value: string
            id: string
          }[]
        }
      }
    }

    const easySearchState = reactive<EasySearchStateTypes>({
      modalOpen: false,
      selectedButton: 'genre',
      conditions: {
        genre: {
          hospital: [
            {
              label: '市中病院',
              value: '1',
              id: 'shityu'
            },
            {
              label: '大学病院',
              value: '2',
              id: 'daigaku'
            },
            {
              label: 'どちらも希望',
              value: '3',
              id: 'both'
            }
          ]
        }
      }
    })

    interface Pref {
      label: string
      value: string
      id: string
      area: string
      checked?: boolean
    }

    const areas: Array<any> = reactive([])
    const tempAreas: Array<string> = []
    const tempItems: Array<Pref> = []

    store.state.master.prefectures.forEach((el: any) => {
      if (el.opt_id === '0') return

      tempAreas.push(el.area)

      const item: Pref = {
        label: el.option_name,
        value: el.opt_id,
        id: 'home_es_prefecture' + el.opt_id,
        area: el.area
      }
      tempItems.push(item)
    })

    const areaNames = Array.from(new Set(tempAreas))

    areaNames.forEach((area) => {
      const prefectures = tempItems.filter((item) => {
        return area === item.area
      })

      areas.push({
        name: area,
        prefectures: prefectures
      })
    })

    const selectedConditions = reactive<any>({
      pr: [],
      cl: ''
    })

    const checkPrefecture = (index: number, prefecture: any) => {
      areas[index].prefectures.forEach((item: Pref) => {
        if (prefecture.value === item.value) item.checked = prefecture.checked
      })

      if (
        prefecture.checked &&
        selectedConditions.pr.indexOf(prefecture.value) === -1
      ) {
        selectedConditions.pr.push(prefecture.value)
      }

      if (
        !prefecture.checked &&
        selectedConditions.pr.indexOf(prefecture.value) > -1
      ) {
        selectedConditions.pr.splice(
          selectedConditions.pr.indexOf(prefecture.value),
          1
        )
      }
    }

    const checkHospital = (value: string) => {
      selectedConditions.cl = value
    }

    const easySearchModal = {
      open: (selected: 'genre' | 'location') => {
        easySearchState.modalOpen = true
        easySearchState.selectedButton = selected
      },
      close: () => {
        easySearchState.modalOpen = false
      },
      change: (selected: 'genre' | 'location') => {
        easySearchState.selectedButton = selected
      },
      submit: () => {
        let url = '/search/hospital/list'

        if (selectedConditions.pr.length > 0) {
          url += '/pr_' + selectedConditions.pr.join('+')

          document.cookie = `searchAreaHome=${selectedConditions.pr[0]}; max-age=31536000; path=/`
        }

        if (selectedConditions.cl === '1' || selectedConditions.cl === '2') {
          url += '/cl_' + selectedConditions.cl
        } else if (selectedConditions.cl === '3') {
          url += '/cl_1+2'
        }

        router.push(url)
      }
    }

    return {
      easySearchState,
      easySearchModal,
      areas,
      selectedConditions,
      checkHospital,
      checkPrefecture
    }
  }
}
